import './polyfills';
import './sentry';
import { Auth0Provider } from '@auth0/auth0-react';
import { createRoot } from 'react-dom/client';
import { AppRoot } from '@/components/AppRoot';
import { AppShell } from '@/components/AppShell';
import { onExecutePostLogin } from './helpers/auth';
import { rootOptions } from './helpers/errors/rootOptions';
import { AUTH_REDIRECT_URL, BASE_URL } from './helpers/url';
import { router } from './router';

if (import.meta.env.DEV && import.meta.env.VITE_MSW === 'true') {
  const [{ startMswWorker }, { mswConfig }] = await Promise.all([
    import('@qdrant-cloud-ui/testing-msw/browser'),
    import('@/test/msw-config'),
  ]);
  await startMswWorker(mswConfig);
}

const container = document.getElementById('root')!;

createRoot(container, rootOptions).render(
  <AppShell>
    <Auth0Provider
      domain={window.__QDRANT_CLOUD__.auth0.domain}
      clientId={window.__QDRANT_CLOUD__.auth0.client_id}
      authorizationParams={{
        audience: window.__QDRANT_CLOUD__.auth0.audience,
        redirect_uri: AUTH_REDIRECT_URL,
        scope: window.__QDRANT_CLOUD__.auth0.scope,
      }}
      onRedirectCallback={(appState, user) => {
        if (user) {
          onExecutePostLogin(user);
        }
        const nextUrl = new URL(appState?.returnTo ?? router.history.location.pathname, BASE_URL);
        if (appState?.intent === 'link') {
          nextUrl.searchParams.set('login_linked', 'true');
        }
        router.history.replace(nextUrl.pathname + nextUrl.search);
      }}
      authorizeTimeoutInSeconds={10}
      useRefreshTokens={true}
      cacheLocation="localstorage"
    >
      <AppRoot router={router} />
    </Auth0Provider>
  </AppShell>,
);
